import { Box } from '@mui/material';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { useLocalStorageStore } from 'store';

let isOnboardingActive = false;

export const Route = createFileRoute('/_authenticated/_onboarding')({
  beforeLoad: () => {
    const { hasSeenOnboarding, setHasSeenOnboarding } = useLocalStorageStore.getState();

    if (hasSeenOnboarding && !isOnboardingActive) {
      throw redirect({ to: '/my-plan' });
    }

    if (!hasSeenOnboarding) {
      setHasSeenOnboarding(true);
    }

    isOnboardingActive = true;
  },
  component: OnboardingLayout,
});

function OnboardingLayout() {
  return (
    <Box component="main">
      <Outlet />
    </Box>
  );
}
